import useFetch from '../../../hooks/useFetch';
import rideApi from '../rideApi';

export default function useRefuserRideApi() {
    return useFetch(rideApi.refuser);
}
